export default __webpack_public_path__ + "static/302-6c4cc88f23058c3cf668e64c18868c1a.gif";